import RouterUtils from "../../../../../shared/routing/RouterUtils";
import {ApiEndpoints} from '../../../../../shared/webservices/endpoint';
import GenericRequest, {METHOD_POST} from '../../../../../shared/webservices/GenericRequest';

export class SendCompanyWorkerMissingInfoEmailTask extends GenericRequest {

    _request; // SendCompanyWorkerMissingInfoEmailRequest

    constructor(id) {
        super(METHOD_POST, RouterUtils.generateRoute(ApiEndpoints.SEND_COMPANY_WORKER_MISSING_INFO_EMAIL, { id }));
        this._request = {};
    }

    overrideRequest() {
        return this._request;
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/worker/form/sendMissingInfoEmail/ws/SendCompanyWorkerMissingInfoEmailTask.js